import { render, staticRenderFns } from "./bonus-schemes.vue?vue&type=template&id=e25bbfd8&"
import script from "./bonus-schemes.vue?vue&type=script&lang=js&"
export * from "./bonus-schemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "bonus-schemes.vue"
export default component.exports